module.exports = __webpack_public_path__ + "static/media/downArrow2.f8c707e8.svg";